/** 입력·선택 컨트롤의 공통 외형. 프로젝트 전체 폼을 바꿀 때 이 기준부터 수정한다. */
export const fieldStyles = {
  control:
    'w-full min-w-0 text-c15 text-foreground outline-none transition-[color,background-color,border-color] duration-200 placeholder:text-description disabled:cursor-not-allowed disabled:opacity-60',
  outline:
    'h-12 rounded-field border border-border bg-background px-4 focus-visible:border-point aria-invalid:border-error aria-invalid:focus-visible:border-error disabled:bg-surface-soft',
  label: 'mb-2 block text-c14 font-medium text-foreground',
  error: 'mt-2 text-c12 leading-5 text-error',
  helper: 'mt-2 text-c12 leading-5 text-description',
} as const
